import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Vuetable from 'vuetable-2';
import Toasted from 'vue-toasted';
import 'vue-simple-context-menu/dist/vue-simple-context-menu.css'
import VueSimpleContextMenu from 'vue-simple-context-menu'
import VueSimpleAlert from "vue-simple-alert";
import VueSocialSharing from 'vue-social-sharing'
import Meta from 'vue-meta';

Vue.config.productionTip = false;

Vue.component('vue-simple-context-menu', VueSimpleContextMenu)

Vue.use(VueSimpleAlert, { reverseButtons: true, confirmButtonText: 'YES, CONFIRM', cancelButtonText: 'NO' });

Vue.use(Toasted, {
  iconPack: 'fontawesome'
});

Vue.toasted.register('app_error',
  payload => {
    if (!payload.message) {
      return "Oops... Something went wrong...";
    } else {
      return "Oops... " + payload.message;
    }
  },
  {
    type: 'error',
    icon: 'fa-exclamation-circle',
    duration: 3000,
    position: 'top-center',
    fitToScreen: true
  });

Vue.toasted.register('app_success',
  payload => {
    if (!payload.message) {
      return "Success!";
    } else {
      return "Success! " + payload.message;
    }
  },
  {
    type: 'success',
    icon: 'fa-check-circle',
    duration: 3000,
    position: 'top-center',
    fitToScreen: true
  });

Vue.use(Vuetable);
Vue.use(VueSocialSharing);
Vue.use(Meta);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
